import { getAnnualReturnUsingRiskScore, RetirementGoal } from '../../../goals';
import { colorsByGoalType } from '../../../goals/colors';
import { getProgressUsingTargetAmount } from '../helpers';
import { BaseGoalConfig } from './types';

export const RETIREMENT: BaseGoalConfig<RetirementGoal> = {
    iconName: 'GoalRetirement',
    color: colorsByGoalType['RETIREMENT'].primary,
    defaultName: 'Retirement',
    getDescription: ({ featureFlags }) => {
        let desc = 'Never request time off again.';
        if (!featureFlags?.isRetirementEnabled) {
            desc += ' IRAs are on their way.';
        }
        return desc;
    },
    group: 'INVEST',
    blogLink: {
        description: 'See Plenty’s primer on retirement',
        url: 'https://www.withplenty.com/blog/retirement-planning-three-things-to-consider',
    },
    getAnnualReturn: getAnnualReturnUsingRiskScore,
    getProgress: (config) => getProgressUsingTargetAmount(config),
};
